import script from "./migrationTransfer.vue?vue&type=script&setup=true&lang=js"
export * from "./migrationTransfer.vue?vue&type=script&setup=true&lang=js"

import "./migrationTransfer.vue?vue&type=style&index=0&id=b26bec0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b26bec0a"]])

export default __exports__